import { AppModules } from 'appContainer/types';
import { AccessControlTabs } from '../navigation/types';

export const ACCESS_CONTROL_ROOT = `/${AppModules.ACCESS_CONTROL_V2}` as const;

export const accessControlRoutes = {
  root: ACCESS_CONTROL_ROOT,
  groupsList:
    `${ACCESS_CONTROL_ROOT}/${AccessControlTabs.PERMISSION_GROUPS}` as const,
  groupDetails:
    `${ACCESS_CONTROL_ROOT}/${AccessControlTabs.PERMISSION_GROUPS}/:groupId` as const,
  usersList: `${ACCESS_CONTROL_ROOT}/${AccessControlTabs.MEMBERS}` as const,
  userProfile:
    `${ACCESS_CONTROL_ROOT}/${AccessControlTabs.MEMBERS}/:userId` as const,
  userProfileRoles:
    `${ACCESS_CONTROL_ROOT}/${AccessControlTabs.MEMBERS}/:userId/roles` as const,
  userProfileGroups:
    `${ACCESS_CONTROL_ROOT}/${AccessControlTabs.MEMBERS}/:userId/groups` as const,
  userProfileAssets:
    `${ACCESS_CONTROL_ROOT}/${AccessControlTabs.MEMBERS}/:userId/assets` as const,
};

export const tabIdToRoute = (tab: AccessControlTabs) =>
  `${ACCESS_CONTROL_ROOT}/${tab}`;
